<script setup>
import { ref } from 'vue';
import InboxReconnectionRequired from '../../components/InboxReconnectionRequired.vue';
import SettingsFieldSection from 'dashboard/components-next/Settings/SettingsFieldSection.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

import instagramClient from 'dashboard/api/channel/instagramClient';

import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

defineProps({
  asPanel: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const isRequestingAuthorization = ref(false);

async function requestAuthorization() {
  try {
    isRequestingAuthorization.value = true;
    const response = await instagramClient.generateAuthorization();

    const {
      data: { url },
    } = response;

    window.location.href = url;
  } catch (error) {
    useAlert(t('INBOX_MGMT.ADD.INSTAGRAM.ERROR_AUTH'));
  } finally {
    isRequestingAuthorization.value = false;
  }
}
</script>

<template>
  <SettingsFieldSection
    v-if="asPanel"
    stacked
    :label="t('INBOX_MGMT.TROUBLESHOOT.META.INSTAGRAM_TITLE')"
    :help-text="t('INBOX_MGMT.TROUBLESHOOT.META.INSTAGRAM_HELP')"
  >
    <NextButton
      :label="t('INBOX_MGMT.TROUBLESHOOT.META.REGAIN_CTA')"
      :is-loading="isRequestingAuthorization"
      @click="requestAuthorization"
    />
  </SettingsFieldSection>
  <InboxReconnectionRequired
    v-else
    class="mx-6"
    @reauthorize="requestAuthorization"
  />
</template>
